module.exports = __webpack_public_path__ + "4f092473dfde2bffc4379b121bbebc0e.MP3";